import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { decorateWith } from 'helpers/decorator';
import { detectScreenType } from 'redux/modules/device';
import { SCREEN_TYPES } from 'constants/media-queries';
import { Image } from 'components/Image/Image';

export const mapStateToProps = state => ({
  isPhone: detectScreenType(state) === SCREEN_TYPES.phone,
});

export const PictureUnwrapped = ({ isPhone, phone, tablet, title }) => {
  const source = isPhone ? phone : tablet;

  return (
    <div className="Picture">
      {isPhone && phone && <Image url={source} alt={title} title={title} />}
      {!isPhone && tablet && <Image url={source} alt={title} title={title} />}
    </div>
  );
};

PictureUnwrapped.propTypes = {
  isPhone: PropTypes.bool,
  phone: PropTypes.string,
  tablet: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export const Picture = decorateWith(connect(mapStateToProps))(PictureUnwrapped);
